/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ServiceRequestType,
} from '../models';
import {
    ServiceRequestTypeFromJSON,
    ServiceRequestTypeToJSON,
} from '../models';

/**
 * 
 */
export class ServiceRequestTypesApi extends runtime.BaseAPI {

    /**
     * Gets a list of service request types
     * Get Service Request Types
     */
    async getServiceRequestTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ServiceRequestType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/serviceRequestType`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ServiceRequestTypeFromJSON));
    }

    /**
     * Gets a list of service request types
     * Get Service Request Types
     */
    async getServiceRequestTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ServiceRequestType>> {
        const response = await this.getServiceRequestTypesRaw(initOverrides);
        return await response.value();
    }

}
